import { EGeoDetailType, IOfferState } from '../../redux/reducers';

export const getLocationPathFromAddress = (offer: IOfferState): Array<number> => {
  const address = offer.geo?.address || [];

  return address.filter(({ type }) => type === EGeoDetailType.location).map(({ id }) => id);
};
